import React from 'react'
import { useSelector } from 'react-redux'
import Button from 'components/Button/Button'
import closeIcon from 'assets/images/icons/close-popup.svg'
import { StyledModalContainer, StyledHeader, StyledProduct } from './ModalTop.styles'
import { selectAddressFormData } from 'slices/addressFormSlice'
import { StyledTag } from 'components/Tag/Tag.style'
import { Chip } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const TopButton = ({ prodcutName }: any) => {
  switch (prodcutName) {
    case 'report':
      return (
        <StyledProduct backgroundColor="#f6f6f6" color="#7C7C7B">
          Report
        </StyledProduct>
      )
    case 'map':
      return (
        <StyledProduct backgroundColor="#fef8ef" color="#F18500">
          Maps
        </StyledProduct>
      )
    case 'index':
      return (
        <StyledProduct backgroundColor="#eff7ff" color="#3F5167">
          Index
        </StyledProduct>
      )
    case 'value':
      return (
        <StyledProduct backgroundColor="#F1F7FE" color="#044F98">
          Value
        </StyledProduct>
      )
    default:
      return <></>
  }
}

function ModalTop({ label, onBackdropClick }: any) {
  const { t } = useTranslation()
  const addressFormData = useSelector(selectAddressFormData)
  const objectType = addressFormData.addressData?.propertyDetails?.objectType

  return (
    <StyledModalContainer>
      <StyledHeader>
        <h1>{label}</h1>
        <TopButton prodcutName={addressFormData.productName} />
        <StyledTag style={{ color: 'inherit' }}>
          {objectType && (
            <Chip
              label={t(`objectType.${objectType.toLowerCase()}.tag`)}
              variant="outlined"
              style={{ lineHeight: '14px' }}
            />
          )}
        </StyledTag>
      </StyledHeader>
      <Button kind="image" onClick={() => onBackdropClick()}>
        <img src={closeIcon} alt="" />
      </Button>
    </StyledModalContainer>
  )
}

export default ModalTop
